import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { toast } from "sonner";
import { motion } from "framer-motion";
import { useAuth } from "@/context/AuthContext";

export default function AdminLogin() {
  const { user, login, checking } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  if (checking) return <div className="min-h-screen flex items-center justify-center">Cargando...</div>;
  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Bienvenido/a");
      nav("/admin");
    } catch (err) {
      const detail = err?.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "Error de autenticación");
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="min-h-screen bg-[#F9F6F0] flex items-center justify-center px-5" data-testid="admin-login-page">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, ease: [0.76, 0, 0.24, 1] }}
        className="w-full max-w-md"
      >
        <div className="flex flex-col items-center mb-10">
          <img src="/kb-logo.png" alt="KB Consultoría" className="h-16 w-auto" />
          <div className="eyebrow mt-6">— Panel administrativo</div>
        </div>
        <form onSubmit={submit} className="border border-[#1A1A1A]/15 bg-white/50 backdrop-blur p-8 space-y-5">
          <h1 className="font-serif text-3xl">Iniciar sesión</h1>
          <div>
            <label className="eyebrow block mb-2">Correo</label>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full bg-transparent border-b border-[#1A1A1A]/25 py-2 focus:border-[#1B3B2B] focus:outline-none"
              data-testid="admin-email"
            />
          </div>
          <div>
            <label className="eyebrow block mb-2">Contraseña</label>
            <input
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full bg-transparent border-b border-[#1A1A1A]/25 py-2 focus:border-[#1B3B2B] focus:outline-none"
              data-testid="admin-password"
            />
          </div>
          <button type="submit" disabled={loading} className="kb-btn w-full justify-center" data-testid="admin-submit">
            {loading ? "Entrando..." : "Entrar"}
          </button>
        </form>
      </motion.div>
    </main>
  );
}
